module.exports = __webpack_public_path__ + "img/tarot-shuffle.dcde7c75.png";